import { jsxs, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { labelStyle } from '../../dropdown.vanilla.mjs';

const RadioGroup = forwardRef(
  ({ title, children, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      DropdownMenuPrimitive.RadioGroup,
      {
        "data-scope": "legacy-dropdown",
        "data-part": "radio-group",
        ref,
        ...props,
        children: [
          !isNil(title) ? /* @__PURE__ */ jsx(DropdownMenuPrimitive.Label, { className: labelStyle, children: title }) : null,
          children
        ]
      }
    );
  }
);

export { RadioGroup };
//# sourceMappingURL=RadioGroup.mjs.map
